import React, { useEffect, useState, useCallback, useRef } from 'react';
import { StyleSheet } from 'react-native';
import { Button, Text } from '@rneui/themed';
import BottomSheet, { BottomSheetScrollView } from '@gorhom/bottom-sheet';
import { Portal } from '@gorhom/portal';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { View } from '../elements';
import { TagList } from './TagList';
import { TagCreateForm } from './TagCreateForm';
import { useTheme } from '../../hooks';
import { BottomSheetBackdrop } from '../shared';
export const TagModal = ({ item, closeModal, isOpen, }) => {
    const { top, bottom } = useSafeAreaInsets();
    const [isCreate, setIsCreate] = useState(false);
    const { colors } = useTheme();
    const bottomSheetRef = useRef(null);
    const handleSheetChanges = useCallback((index) => {
        if (index < 0) {
            closeModal();
        }
    }, []);
    useEffect(() => {
        if (isOpen === true) {
            bottomSheetRef.current?.snapToPosition(0);
        }
    }, [isOpen]);
    return (React.createElement(Portal, null,
        React.createElement(BottomSheet, { ref: bottomSheetRef, backdropComponent: BottomSheetBackdrop, index: 1, topInset: top, enablePanDownToClose: true, enableDynamicSizing: false, animateOnMount: true, snapPoints: ['75%', '100%'], onChange: handleSheetChanges, backgroundStyle: { backgroundColor: colors.backgroundPrimary }, handleIndicatorStyle: { backgroundColor: colors.textPrimary }, containerStyle: { zIndex: 4000 } },
            React.createElement(BottomSheetScrollView, { style: { paddingBottom: bottom } },
                React.createElement(View, { style: styles.headerContainer },
                    React.createElement(Text, { h2: true, bold: true }, isCreate === false ? 'Choose Tags' : 'Create Tag'),
                    React.createElement(Button, { onPress: () => setIsCreate(!isCreate), title: isCreate === false ? 'New Tag' : 'Select Tag' })),
                isCreate === false ?
                    (React.createElement(TagList, { item: item })) :
                    (React.createElement(TagCreateForm, { item: item, onCreate: () => setIsCreate(false) }))))));
};
const styles = StyleSheet.create({
    headerContainer: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 15,
    },
});
//# sourceMappingURL=TagModal.js.map